import { createMongoAbility } from '@casl/ability'

// El backend (AuthController) y Layout.vue arman las reglas con el formato de CASL 3:
// { subject, actions }. CASL 4+ solo entiende `action`; sin esta traduccion todas las
// reglas quedarian sin accion y $can() devolveria false para todo.
function normalizeRules (rules) {
  return (rules || []).map(({ actions, ...rule }) =>
    actions !== undefined && rule.action === undefined ? { ...rule, action: actions } : rule
  )
}

const ability = createMongoAbility([])
const update = ability.update.bind(ability)
ability.update = rules => update(normalizeRules(rules))

export default ability
